// @owners { team: patients-team }
export const FEDEX_ACCOUNT_LINK = 'https://www.fedex.com/en-us/delivery-manager.html';
export const USPS_ACCOUNT_LINK = 'https://www.usps.com/manage/informed-delivery.htm';
